import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const Bar = ({ label, used, limit, testId }) => {
  const unlimited = !limit;
  const pct = unlimited ? 0 : Math.min(100, (used / limit) * 100);
  const color = pct >= 90 ? "bg-rose-600" : pct >= 70 ? "bg-amber-500" : "bg-emerald-500";
  return (
    <div className="min-w-[180px]" data-testid={testId}>
      <div className="flex justify-between gap-4 text-[11px] font-mono uppercase tracking-wider text-muted-foreground mb-1.5">
        <span>{label}</span>
        <span className="text-foreground">{unlimited ? `${used} · Unlimited` : `${used} / ${limit}`}</span>
      </div>
      <div className="h-1.5 rounded-full bg-secondary overflow-hidden">
        <div className={`h-full ${color} transition-[width] duration-700`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export const useUsage = () => {
  const [usage, setUsage] = useState(null);
  const reload = useCallback(() => api.get("/me/usage").then((r) => setUsage(r.data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  return [usage, reload];
};

export const QuestionAllowance = ({ usage, limitReached }) => {
  if (!usage?.questions_limit) return null;
  const n = new Date();
  const reset = new Date(n.getFullYear(), n.getMonth() + 1, 1).toLocaleDateString("en-GB", { day: "numeric", month: "long" });
  const most = usage.questions_limit && usage.questions_used >= 0.75 * usage.questions_limit;
  const msg = !limitReached ? (most ? "You've used most of this month's questions." : "You have plenty of questions available this month.")
    : usage.trial ? "You've used your free trial questions. Choose a membership to keep asking."
    : `You've reached your question limit for this month. Upgrade to Pro for unlimited questions plus fortnightly group calls with Lindsay — or your allowance resets on ${reset}.`;
  return (
    <div className={`mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl px-4 py-3 text-sm ${limitReached ? "bg-pinkb/5 border border-pinkb/30" : "bg-secondary"}`} data-testid="question-allowance">
      <span data-testid="questions-left">{msg}</span>
      {limitReached && <Link to="/app/membership" data-testid="upgrade-pro-link" className="rounded-full bg-pinkb text-white px-4 py-1.5 text-sm">{usage.trial ? "Choose a membership" : "Upgrade to Pro"}</Link>}
    </div>
  );
};

export const UsageMeter = ({ usage, only }) => {
  if (!usage?.questions_limit) return null;
  return (
    <div className="flex flex-wrap gap-6 rounded-xl border border-border bg-card/70 backdrop-blur px-5 py-4" data-testid="usage-meter">
      {only !== "uploads" && <QuestionAllowance usage={usage} limitReached={usage.questions_limit > 0 && usage.questions_used >= usage.questions_limit} />}
    </div>
  );
};
